import { render } from "./RankingTable008.vue?vue&type=template&id=747724e4&scoped=true"
import script from "./RankingTable008.vue?vue&type=script&lang=js"
export * from "./RankingTable008.vue?vue&type=script&lang=js"

import "./RankingTable008.vue?vue&type=style&index=0&id=747724e4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-747724e4"]])

export default __exports__